import { Paper, Typography } from '@mui/material';
import { letterByNumber } from '../grid-generator';

interface Props {
    col: number;
    row: number;
    isOccupied: boolean;
    teamColor?: string;
    isHighlighted: boolean;
    onClick: () => void;
    onMouseEnter (row: number, col: number ): void;
    children?: React.ReactNode;
}

export const BoardSquare = ({ col, row, isOccupied, teamColor, isHighlighted, onClick, onMouseEnter, children }: Props) => {
    const calcBackgroundColor = (isOccupied: boolean, isHighlighted: boolean, teamColor?: string): string => {
        if (isOccupied && isHighlighted) {
            return 'red';
        }
        if (isOccupied) {
            return teamColor!;
        }
        if (isHighlighted) {
            return 'lightgray';
        }

        return 'white';
    };

    const style = {
        width: 50,
        height: 50,
        backgroundColor: calcBackgroundColor(isOccupied, isHighlighted, teamColor),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid black'
    };

    const label = `${letterByNumber(col)}${row + 1}`;

    return (
        <Paper style={style} onClick={onClick} onMouseEnter={() => onMouseEnter(row, col)}>
            <Typography>{label}</Typography>
            {children}
        </Paper>
    );
};
